export const getTokenFromStorage = (): string | null => {
    const raw = localStorage.getItem('APP_ACCESS_TOKEN');
    
    if (!raw) return null;
  
    try {
      const parsed = JSON.parse(raw);
      return parsed?.token || null;
    } catch (error) {
      console.error('Erro ao fazer parse do token:', error);
      return null;
    }
  };